var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-row",
    [
      _c(
        "w-col",
        { attrs: { xs: "12", md: "6" } },
        [
          _c("app-label", {
            attrs: { label: "Username", value: _vm.value.username },
          }),
        ],
        1
      ),
      _c(
        "w-col",
        { attrs: { xs: "12", md: "6" } },
        [
          _c("app-label", {
            attrs: { label: "email", value: _vm.value.email },
          }),
        ],
        1
      ),
      _c(
        "w-col",
        { attrs: { xs: "12", md: "6" } },
        [
          _c("app-label", {
            attrs: { label: "Firstname", value: _vm.value.firstname },
          }),
        ],
        1
      ),
      _c(
        "w-col",
        { attrs: { xs: "12", md: "6" } },
        [
          _c("app-label", {
            attrs: { label: "Lastname", value: _vm.value.lastname },
          }),
        ],
        1
      ),
      _c(
        "w-col",
        { attrs: { xs: "12" } },
        [
          _c("app-label", {
            attrs: { label: "Phone", value: _vm.value.phone },
          }),
        ],
        1
      ),
      _c(
        "w-col",
        { attrs: { xs: "12" } },
        [
          _c(
            "w-row",
            { attrs: { "no-margin": "" } },
            [
              _c("app-label", {
                attrs: { label: "Activated", value: _vm.value.activated },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }